import { locale as configLocale } from '@local/config';
import es from './es.json';
import en from './en.json';
import vi from './vi.json';

const strings = { es, en, vi };

export const getI18n = locale =>
  strings[locale || configLocale()] || strings.en;
